export const PAGE_SCHEME_ACTION_URL_PARAM_KEY = 'pscme';
export const OPEN_NEW_WINDOW_PARAM_KEY = 'pnwindow';

export const APP_LINK_FALLBACK_QUERY_KEY = 'alfallback';
export const PAGE_REDIRECT_URL_PARAM_KEY = 'prurl';
export const PAGE_LINK_PAGE_URL_PARAM_KEY = 'plpu';
/** 페이지웹에서 브릿지페이지로 뒤로가기 할 때 동작을 막기 위해 세션스토리지에 저장된 uid로 비교합니다. */
export const LINK_PAGE_UID = 'lpuid';

export const LINK_ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=com.kakao.page&amp;referrer=';
export const LINK_IOS_STORE =
  'https://itunes.apple.com/kr/app/kakaopeiji/id616643813';
